// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const RefreshCwIcon = /* @__PURE__ */ createIcon(
  'refresh-cw',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M1.5 12c0-5.523 4.477-10 10-10a9.97 9.97 0 0 1 7.073 2.932c.64.64 1.325 1.43 1.927 2.162V4a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h3.968c-.692-.869-1.551-1.897-2.309-2.655A7.97 7.97 0 0 0 11.5 4a8 8 0 1 0 7.688 10.223 1 1 0 0 1 1.921.554C19.906 18.948 16.06 22 11.5 22c-5.523 0-10-4.477-10-10',
      },
    ],
  ]
);
